/**
 * luogoNascita.js — che luogo dice il codice fiscale (3 ottobre 2026, ramo
 * cf-estero).
 *
 * Il codice del luogo (posizioni 12-15, omocodia tradotta) lo legge
 * `luogoDalCF` di utils/codiceFiscale.js; il NOME lo sa il server
 * (/api/comuni/luogo, tabelle comuni, stati_esteri e comuni_ceduti della
 * migration 287). Al server va solo il codice del luogo, quattro caratteri,
 * mai il codice fiscale: nell'indirizzo non passa niente che identifichi una
 * persona.
 *
 * Funziona alla postazione (gettone) e al tablet (chiave del dispositivo
 * nell'intestazione, mai nell'indirizzo: utils/chiaveDispositivo.js).
 *
 * Restituisce i dati del luogo ({ tipo: 'comune' | 'stato' | 'ceduto' |
 * 'sconosciuto', nome, ... , coincide, nota }) oppure null se non si e'
 * riusciti a chiedere: un luogo che non si sa non si propone.
 */
import intestazioniTablet from './chiaveDispositivo';

export async function chiediLuogo(codice, { chiave = null, stato = '' } = {}) {
    if (!/^[A-Z][0-9]{3}$/.test(String(codice || ''))) return null;
    const par = new URLSearchParams({ codice });
    if (String(stato || '').trim()) par.set('stato', String(stato).trim());
    const intestazioni = intestazioniTablet(chiave);
    if (!chiave) {
        const token = localStorage.getItem('token');
        if (token) intestazioni.Authorization = `Bearer ${token}`;
    }
    try {
        const r = await fetch(`/api/comuni/luogo?${par}`, { headers: intestazioni });
        if (!r.ok) return null;
        const d = await r.json();
        return d && d.success ? d.data : null;
    } catch (e) {
        return null;
    }
}

export default chiediLuogo;
